import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./UserPlanStyle.css";
import "../ProjectV2/Render/RenderStyle.css";

import Navbar from "../ProjectV2/Navbar/Navbar";
import UserPlanNav from "./UserPlanNav";
import SliderRectCard from "./SliderRectCard";
import PaymentsDetails from "../UserPlan/PaymentsDetails";
import FreePlanConfirmModal from "./FreePlanConfirmModal";

import { useDispatch, useSelector } from "react-redux";
import {
  createCheckoutSession,
  getCurrentPlan,
  getRendersPlan,
  getUserAllInformation,
  PlanHandler,
  updateUserCardInfo,
} from "../../Redux/actions/commonActtion";

import { toast } from "react-toastify";
import CustomToast, {
  defaultcustomToatStyle,
} from "../../Components/CustomToast/CustomToast";
import { Loader2 } from "../../Components";

const OnSubscriptionPlanList = ({
  setRenderOpen,
  isPlanShow,
  setIsPlanShow,
}) => {
  const location = useLocation();
  const { isDashboard, projectId, isCard, pathSegment, isMoreInfo, isRender } =
    location.state || {};

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));

  const [currentPlanRange, setCurrentPlanRange] = useState({
    start: 0,
    end: 2,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [isFreePlanModalOpen, setIsFreePlanModalOpen] = useState(false);
  const [pendingFreePlan, setPendingFreePlan] = useState(null);

  const { renderPlan, userData } = useSelector((state) => state.commonReducer);
  const commonReducer = useSelector((state) => state?.commonReducer);
  const currentPlan = commonReducer?.currentPlan;
  const subscription_status =
    commonReducer?.currentPlan?.plan?.subscription_status;
  const isExpired = commonReducer?.currentPlan?.isExpired;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;
  const [isUserPaid, setIsUserPaid] = useState(
    currentPlan.success && currentPlan.plan ? true : false,
  );

  // ✅ Check if user has card added
  const isCardAdded = userData?.[0]?.isCardAdded;

  useEffect(() => {
    const fetchInitialData = async () => {
      setIsDataLoading(true);
      try {
        await dispatch(getCurrentPlan());
        await dispatch(getUserAllInformation());
        await getRenderPlanDetails();
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsDataLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    getRenderPlanDetails();
  }, [isSuccessOpen]);

  const getRenderPlanDetails = async () => {
    await dispatch(getRendersPlan(user));
    await dispatch(getCurrentPlan());
  };

  // Add this function to handle Stripe checkout
  const handlePlanUpgrade = async (plan) => {
    if (plan.price === 0) {
      toast(
        <CustomToast title="" content="You're already on the free plan" />,
        defaultcustomToatStyle,
      );
      return;
    }

    setIsLoading(true);
    try {
      const response = await dispatch(createCheckoutSession(plan._id));
      console.log(response);

      if (response?.data?.session) {
        window.location.href = response?.data?.session?.url;
      } else {
        toast(
          <CustomToast
            title="Error"
            content="Something went wrong. Please try again."
          />,
          defaultcustomToatStyle,
        );
      }
    } catch (error) {
      toast(
        <CustomToast
          title="Error"
          content="Something went wrong. Please try again."
        />,
        defaultcustomToatStyle,
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Update your existing click handler
  const handlePlanClick = async (plan) => {
    if (plan.price === 0) {
      // Show confirmation modal for free plan
      setPendingFreePlan(plan);
      setIsFreePlanModalOpen(true);
    } else if (!isExpired) {
      handleUpgradeOnSubscriptionActive(plan);
    } else {
      await handlePlanUpgrade(plan);
    }
  };

  useEffect(() => {
    const isExpired = commonReducer?.currentPlan?.isExpired;
    if (!isDataLoading && isCardAdded && !isExpired) {
      navigate("/dashboard");
    }
  }, [isDataLoading, isCardAdded, commonReducer?.currentPlan?.isExpired, navigate]);

  const createdAt = new Date(currentPlan?.plan?.createdAt);
  const planPurchaseDate = isNaN(createdAt.valueOf())
    ? ""
    : `${createdAt?.getDate()}/${
        createdAt?.getMonth() + 1
      }/${createdAt?.getFullYear()}`;

  const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0;
  const [remainingDays, setRemainingDays] = useState("");
  const [remainingHours, setRemainingHours] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const today = new Date();
  const planRenewDate = new Date(
    createdAt?.getTime() + validityValue * 24 * 60 * 60 * 1000,
  );
  let timeDifference = planRenewDate - today;

  useEffect(() => {
    let prevRemainingDays = remainingDays;

    if (remainingDays === 1 || validityValue === 1) {
      const interval = setInterval(() => getTime(prevRemainingDays), 1000);
      return () => clearInterval(interval);
    } else {
      getTime(prevRemainingDays);
    }
  }, [remainingDays, validityValue, timeDifference]);

  const getTime = async (prevRemainingDays) => {
    if (!isNaN(validityValue)) {
      if (timeDifference > 0) {
        if (timeDifference >= 24 * 60 * 60 * 1000) {
          const updatedRemainingDays = Math.ceil(
            timeDifference / (24 * 60 * 60 * 1000),
          );
          timeDifference -= updatedRemainingDays * 24 * 60 * 60 * 1000;

          if (prevRemainingDays === 1 && updatedRemainingDays === 0) {
            setRemainingHours(0);
            setRemainingMinutes(0);
            setRemainingSeconds(0);
            setIsUserPaid(false);
          }
          setRemainingDays(updatedRemainingDays);
        }
        if (timeDifference >= 60 * 60 * 1000) {
          setRemainingHours(Math.floor(timeDifference / (60 * 60 * 1000)));
          timeDifference -= remainingHours * 60 * 60 * 1000;
        }

        if (timeDifference >= 60 * 1000) {
          setRemainingMinutes(Math.floor(timeDifference / (60 * 1000)));
          timeDifference -= remainingMinutes * 60 * 1000;
        }

        setRemainingSeconds(Math.floor(timeDifference / 1000));
      } else if (remainingDays === 0) {
        setIsUserPaid(false);
      } else {
        setRemainingDays(0);
        setRemainingHours(0);
        setRemainingMinutes(0);
        setRemainingSeconds(0);
      }
    }
  };

  const expirationMessage =
    remainingDays === 1 || validityValue === 1
      ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}`
      : remainingDays > 1
        ? `Remaining days ${remainingDays}`
        : Object.keys(currentPlan).length === 0
          ? "Buy New Plan"
          : "Plan Expired ";

  const goToNextPlan = () => {
    if (currentPlanRange.end < renderPlan.length - 1) {
      setCurrentPlanRange({
        start: currentPlanRange.start + 1,
        end: currentPlanRange.end + 1,
      });
    }
  };

  const goToPreviousPlan = () => {
    if (currentPlanRange.start > 0) {
      setCurrentPlanRange({
        start: currentPlanRange.start - 1,
        end: currentPlanRange.end - 1,
      });
    }
  };

  const isEmptyObject =
    currentPlan &&
    Object.keys(currentPlan).length === 0 &&
    currentPlan.constructor === Object;

  const handleUpgradeOnSubscriptionActive = (plan) => {
    if (
      plan?._id !== currentPlan?.plan?.plan_detail?._id &&
      plan?.price !== 0
    ) {
      toast(
        <CustomToast
          title=""
          content={
            "You're already subscribed, Please cancel your current plan first and then upgrade your plan"
          }
        />,
        defaultcustomToatStyle,
      );
    }
  };

  // Handle free plan confirmation
  const handleFreePlanConfirm = async () => {
    try {
      await dispatch(updateUserCardInfo());
      setIsFreePlanModalOpen(false);
      setPendingFreePlan(null);
      navigate("/dashboard");
    } catch (error) {
      toast(
        <CustomToast
          title="Error"
          content="Something went wrong. Please try again."
        />,
        defaultcustomToatStyle,
      );
    }
  };

  // Handle free plan cancel
  const handleFreePlanCancel = () => {
    setIsFreePlanModalOpen(false);
    setPendingFreePlan(null);
  };

  // ✅ Show loading screen while fetching user data
  if (isDataLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-[#121212]">
        <div className="text-center">
          <Loader2/>
        </div>
      </div>
    );
  }

  return (
    <>
      {isPlanShow || (
        <div className="w-full h-full">
          <div className={`UpgradePlan-container`}>
            <div className="UpgradePlan-content w-full ">
              <div className="UpgradePlan-header h-[6.8%] w-full h-hull flex items-center pl-[3px] pr-[3px] bg-[#171717]">
                <UserPlanNav />
              </div>

              <div className="UpgradePlan-contentt w-full h-[93.2%] SCalePlan">
                <div className="w-full h-[13.5%] flex flex-col justify-end items-center text-center bg-[#121212] headcontent">
                  <h1 className="text-[42px] manrope-600 py-2 tracking-wide text-white">
                    Choose the plan that fits your needs
                  </h1>
                  <h2 className="text-[16px] manrope-400 tracking-wide text-[#ffffffcc]">
                    From quick turn arrounds to long-term projects, we've got a
                    plan that's just right for you
                  </h2>
                </div>
                <div className="h-[90%] flex justify-center items-center">
                  <div className="flex justify-center items-center pb-[2.5%] pt-[1%] h-full w-[65%] mr-[3.2rem]">
                    {renderPlan
                      .slice(currentPlanRange.start, currentPlanRange.end + 1)
                      .map((plan, ind) => (
                        <div
                          className={`w-[29%] plan-box rounded-[20px] UpgradePlanBG p-5 ${
                            ind === 1 ? "mx-[5%]" : ""
                          } 
                    ${
                      subscription_status === 1 && plan?.price !== 0
                        ? ""
                        : "cursor-pointer HoverPlanCLASS"
                    }
                    ${isLoading ? "opacity-50 pointer-events-none" : ""} ${plan?.price === 0 ? "hidden" : ""} `}
                          key={`upg${ind + 1}`}
                          onClick={() => handlePlanClick(plan)}
                        >
                          <SliderRectCard
                            planId={plan?._id}
                            plantype={plan?.type}
                            planText={plan?.text5}
                            moneyBackText={plan?.text6}
                            currency={plan?.currency}
                            PlanPrice={plan?.price}
                            PlanInterval={plan?.interval_validity}
                            renderLimit={plan?.text1}
                            renderType={plan?.text2}
                            formateType={plan?.text3}
                            cancelCondition={plan?.text4}
                            daysLimit={plan?.validity}
                            currentPlan={currentPlan}
                            currentPlanDetails={currentPlanDetails}
                            currentPlanId={currentPlanDetails?._id}
                            subscription_status={subscription_status}
                            isExpired={commonReducer?.currentPlan?.isExpired}
                          />
                          {isLoading && (
                            <div className="absolute inset-0 flex items-center justify-center">
                              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </div>

                {isOpen && (
                  <PaymentsDetails
                    setRenderOpen={setRenderOpen}
                    isPlanShow={isPlanShow}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    selectedPlan={selectedPlan}
                    currentPlanDetails={currentPlanDetails}
                    paymentType={currentPlan?.plan?.payment_type}
                    order_id={currentPlan?.plan?.order_id}
                    subscription_status={currentPlan?.plan?.subscription_status}
                    planPurchaseDate={planPurchaseDate}
                    getTime={getTime}
                    remainingDays={remainingDays}
                    expirationMessage={expirationMessage}
                    setIsSuccessOpen={setIsSuccessOpen}
                  />
                )}

                {/* Free Plan Confirmation Modal */}
                <FreePlanConfirmModal
                  isOpen={isFreePlanModalOpen}
                  onConfirm={handleFreePlanConfirm}
                  onCancel={handleFreePlanCancel}
                  planName={pendingFreePlan?.type || "Free"}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OnSubscriptionPlanList;
